import { render } from "./taohaohaoMerchant.vue?vue&type=template&id=6401d818&scoped=true"
import script from "./taohaohaoMerchant.vue?vue&type=script&lang=js"
export * from "./taohaohaoMerchant.vue?vue&type=script&lang=js"

import "./taohaohaoMerchant.vue?vue&type=style&index=0&id=6401d818&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6401d818"]])

export default __exports__